import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web-public/web-public/app/components/pages/newsletter.client.js");
